import { IAppState } from '@state/types';

export const getToken = (state: IAppState): string | undefined => state.storage.token;

export const getFileResponse = (state: IAppState): any | undefined => state.storage.response;